import React, { useEffect, useState } from "react";
import PropTypes from "prop-types";

import { MerchantName } from "@/components/atoms/Typography/styles";

function MerchantLogo({ name, slug, width, height }) {
  const [isError, setIsError] = useState(false);

  useEffect(() => {
    setIsError(false);
  }, [slug]);

  if (isError) {
    return <MerchantName>{name}</MerchantName>;
  }

  return (
    <img
      alt={name || ""}
      className="absolute left-5"
      style={{
        width: width || "auto",
        minHeight: height,
      }}
      onError={() => setIsError(true)}
      src={`/images/merchant/${slug}.svg`}
      title={name || ""}
    />
  );
}

MerchantLogo.propTypes = {
  name: PropTypes.string,
  slug: PropTypes.string,
  width: PropTypes.string,
  height: PropTypes.string,
};

export default MerchantLogo;
